import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import SectionTitle from '../elements/section-title/SectionTitle';
import ServicePropOne from '../component/service/ServicePropOne';
import { useLanguage } from '../context/LanguageContext';
import { Features } from '../assets/features/Features';


const ServiceOne = () => {
    const { language } = useLanguage();

    const ServicesAnimation = () => (
        <div className="services-animation">
            <svg viewBox="0 0 500 300" className="services-svg">
                {/* Professional Truck - Static but elegant */}
                <g transform="translate(150, 100)">
                    {/* Truck Body */}
                    <rect x="0" y="0" width="200" height="80" fill="#2c3e50" rx="5"/>
                    <rect x="0" y="20" width="200" height="60" fill="#34495e"/>
                    
                    {/* Truck Cabin */}
                    <rect x="200" y="10" width="80" height="70" fill="#2c3e50" rx="5"/>
                    <rect x="205" y="15" width="70" height="60" fill="#3498db" opacity="0.2"/>
                    
                    {/* Wheels */}
                    <circle cx="50" cy="80" r="18" fill="#1a252f"/>
                    <circle cx="50" cy="80" r="10" fill="#ecf0f1"/>
                    <circle cx="150" cy="80" r="18" fill="#1a252f"/>
                    <circle cx="150" cy="80" r="10" fill="#ecf0f1"/>
                    <circle cx="230" cy="80" r="18" fill="#1a252f"/>
                    <circle cx="230" cy="80" r="10" fill="#ecf0f1"/>
                    
                    {/* Subtle boxes on truck */}
                    <rect x="20" y="-10" width="40" height="10" fill="#e74c3c" opacity="0.6"/>
                    <rect x="70" y="-15" width="40" height="15" fill="#3498db" opacity="0.6"/>
                    <rect x="120" y="-12" width="40" height="12" fill="#2ecc71" opacity="0.6"/>
                </g>
                
                {/* Service Icons - Clean and minimal */}
                <g transform="translate(100, 200)">
                    <rect x="0" y="0" width="60" height="60" fill="none" stroke="#3498db" strokeWidth="2" rx="3"/>
                    <path d="M30 15 L30 30 L45 30" fill="none" stroke="#3498db" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="30" cy="40" r="5" fill="#3498db"/>
                </g>
                
                <g transform="translate(220, 200)">
                    <rect x="0" y="0" width="60" height="60" fill="none" stroke="#2ecc71" strokeWidth="2" rx="3"/>
                    <rect x="15" y="15" width="30" height="30" fill="none" stroke="#2ecc71" strokeWidth="2"/>
                    <line x1="15" y1="30" x2="45" y2="30" stroke="#2ecc71" strokeWidth="2"/>
                </g>
                
                <g transform="translate(340, 200)">
                    <rect x="0" y="0" width="60" height="60" fill="none" stroke="#e74c3c" strokeWidth="2" rx="3"/>
                    <path d="M30 15 L20 25 L30 35 L40 25 Z" fill="none" stroke="#e74c3c" strokeWidth="2"/>
                </g>
            </svg>
            <style jsx>{`
                .services-animation {
                    width: 100%;
                    height: 100%;
                    min-height: 300px;
                    display: block;
                    position: relative;
                }
                .services-svg {
                    width: 100%;
                    height: 100%;
                    min-height: 300px;
                    display: block;
                }
            `}</style>
        </div>
    );

    return (
        <>
        <SEO title={Features.SERVICES_PAGE.TITLE[language]} />
        <ColorSwitcher />
        <main className="main-wrapper">
            <HeaderOne />
            <div className="breadcrum-area">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="section-heading heading-left">
                                <h1 className="title h2">{Features.SERVICES_PAGE.TITLE[language]}</h1>
                                <p>{Features.SERVICES_PAGE.SUBTITLE[language]}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 d-none d-lg-block">
                            <ServicesAnimation />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="section section-padding" id="section1">
                <div className="container">
                    <SectionTitle 
                        subtitle={Features.SERVICES_PAGE.SECTION_SUBTITLE[language]}
                        title={Features.SERVICES_PAGE.SECTION_TITLE[language]}
                        description=""
                        textAlignment="heading-left"
                        textColor=""
                        subtitlePurple={true}
                    />
                    <div className="row">
                        <ServicePropOne colSize="col-lg-4 col-md-6" serviceStyle="service-style-2" itemShow="3"/>
                    </div>
                </div>
            </div>

            <CtaLayoutOne />
            <FooterOne parentClass="" />
        </main>
        </>
    )
}

export default ServiceOne;